export default __webpack_public_path__ + "static/media/small-3.57ce95ca.jpg";